/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Answers from './Answers/index'
import CancelAction from './CancelAction/index'
import CommunicationPreferences from './CommunicationPreferences/index'
import CreateNoteAction from './CreateNoteAction/index'
import DismissAction from './DismissAction/index'
import Heading from './Heading/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import MiscStats from './MiscStats/index'
import NextAction from './NextAction/index'
import Notes from './Notes/index'
import PatientAction from './PatientAction/index'
import PersonDetails from './PersonDetails/index'
import PreviousAction from './PreviousAction/index'
import React from 'react'
import ResponsiblePersonDetails from './ResponsiblePersonDetails/index'
import TysaiaProfileSectionNoDetails from 'DesignSystem/TysiaProfileElements/TysaiaProfileSectionNoDetails/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content",
  handleClose,
  showNextActions,
  onClickPrevAction,
  prevActionDisabled,
  onClickNextAction,
  nextActionDisabled,
  hideActions
  
}) {
let leadMetadataResponsibleFirstnameValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.responsible.firstName',
})
let leadMetadataResponsibleFirstnameValueData1 = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.responsible.firstName',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let leadMetadataAnswersValueData = fromData.useDataFormat({ viewPath,
context: 'lead',
path: 'metadata.answers',
format: fromFormat.isEmptyList,
})
let leadMetadataAnswersValueData1 = fromData.useDataFormat({ viewPath,
context: 'lead',
path: 'metadata.answers',
format: fromFormat.isEmptyList,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 height="auto"
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<Heading
{...childProps}
  viewPath={`${viewPath}/Heading`}
 handleClose={handleClose}
/>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Person/Patient Details"
 level="h4"
/>
<PersonDetails
  viewPath={`${viewPath}/PersonDetails`}
/>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Responsible Person Details"
 level="h4"
/>
<fromFlow.When is={!leadMetadataResponsibleFirstnameValueData}>
<TysaiaProfileSectionNoDetails
  viewPath={`${viewPath}/TysaiaProfileSectionNoDetails`}
 data="lead.metadata.responsible.firstName"
/>
</fromFlow.When>
<fromFlow.When is={leadMetadataResponsibleFirstnameValueData1}>
<ResponsiblePersonDetails
  viewPath={`${viewPath}/ResponsiblePersonDetails`}
 data="lead.metadata.responsible.firstName"
/>
</fromFlow.When>
</div>
</div>
<HorizontalDivider
{...childProps}
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
/>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical2}`}
>
<CommunicationPreferences
  viewPath={`${viewPath}/CommunicationPreferences`}
/>
</div>
<HorizontalDivider
{...childProps}
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
/>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical3}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Additional Questions"
 level="h4"
/>
<fromFlow.When is={leadMetadataAnswersValueData}>
<TysaiaProfileSectionNoDetails
  viewPath={`${viewPath}/TysaiaProfileSectionNoDetails`}
 data="lead.metadata.answers"
 format="/Data/format.js isEmptyList"
/>
</fromFlow.When>
<fromFlow.When is={!leadMetadataAnswersValueData1}>
<Answers
  viewPath={`${viewPath}/Answers`}
 data="lead.metadata.answers"
 format="/Data/format.js isEmptyList"
/>
</fromFlow.When>
</div>
<HorizontalDivider
{...childProps}
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
/>
<div
  data-testid="Content.Vertical:4"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical4}`}
>
<MiscStats
  viewPath={`${viewPath}/MiscStats`}
/>
</div>
<HorizontalDivider
{...childProps}
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
/>
<div
  data-testid="Content.Vertical:5"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical5}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Notes"
 level="h4"
/>
<CreateNoteAction
  viewPath={`${viewPath}/CreateNoteAction`}
/>
</div>
<Notes
  viewPath={`${viewPath}/Notes`}
/>
</div>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<fromFlow.When is={showNextActions}>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<PreviousAction
  viewPath={`${viewPath}/PreviousAction`}
 onClickPrevAction={onClickPrevAction}
 prevActionDisabled={prevActionDisabled}
/>
<NextAction
  viewPath={`${viewPath}/NextAction`}
 onClickNextAction={onClickNextAction}
 nextActionDisabled={nextActionDisabled}
/>
</div>
</fromFlow.When>
<div
  data-testid="Content.Horizontal:4"
  data-view-path={viewPath}
 style={{'--g-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal4}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
 handleClose={handleClose}
/>
<fromFlow.When is={!hideActions}>
<DismissAction
  viewPath={`${viewPath}/DismissAction`}
/>
</fromFlow.When>
<fromFlow.When is={!hideActions}>
<PatientAction
  viewPath={`${viewPath}/PatientAction`}
/>
</fromFlow.When>
</div>
</div>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}